import { FadeUp } from "./Reveal";

const STATS = [
  { value: "DTC", label: "Digital Tech & Culture" },
  { value: "2027", label: "Class of" },
];


export default function About() {
  return (
    <section id="about" data-testid="about-section" className="relative mx-auto max-w-[1400px] px-6 py-16 md:px-10 md:py-24">
      <FadeUp>
        <div className="mb-10 md:mb-14">
          <p className="mb-4 font-jbmono text-xs uppercase tracking-[0.3em] text-[#00E5FF]">About</p>
          <h2 className="font-display text-4xl font-black uppercase tracking-tight md:text-6xl">
            About
            <br />
            <span className="text-stroke">me</span>
          </h2>
        </div>
      </FadeUp>

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-12 md:gap-8">
        <FadeUp className="lg:col-span-7">
          <div className="card-lift flex h-full flex-col justify-between rounded-2xl border border-white/10 bg-[#0a0a0a] p-8 md:p-12">
            <div>
              <p className="font-display text-2xl font-bold leading-snug tracking-tight md:text-4xl">
                I&apos;m a Digital Technology and Culture student at <span className="mx-[0.12em] text-[#00E5FF]">WSU Tri-Cities</span> with an interest in
                graphic design, web design, photography, video, and digital media.
              </p>
              <p className="mt-6 max-w-xl text-base leading-relaxed text-zinc-400 md:text-lg">
                I enjoy experimenting with different styles, textures, and techniques while
                learning how design can communicate ideas in creative ways. My work ranges
                from clean and structured designs to more experimental projects, and I&apos;m
                continuing to build my skills while developing my own creative style.
              </p>
            </div>

            <div className="mt-10 grid grid-cols-2 gap-x-6 gap-y-8 border-t border-white/10 pt-8" data-testid="about-stats-card">
              {STATS.map((s) => (
                <div key={s.label}>
                  <div className="font-display text-3xl font-black text-white md:text-4xl" data-testid={`about-stat-${s.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
                    {s.value}
                  </div>
                  <div className="mt-2 font-jbmono text-[10px] uppercase tracking-[0.2em] text-zinc-500">
                    {s.label}
                  </div>
                </div>
              ))}
            </div>

            <ul className="mt-8 flex flex-wrap gap-x-8 gap-y-3 border-t border-white/10 pt-6 font-jbmono text-xs uppercase tracking-[0.2em] text-zinc-400">
              <li className="flex items-center gap-3" data-testid="about-focus-adobe">
                <span className="h-1.5 w-1.5 rounded-full bg-[#00E5FF]" /> Adobe Suite
              </li>
              <li className="flex items-center gap-3" data-testid="about-focus-web">
                <span className="h-1.5 w-1.5 rounded-full bg-[#00E5FF]" /> Website design
              </li>
              <li className="flex items-center gap-3" data-testid="about-focus-product">
                <span className="h-1.5 w-1.5 rounded-full bg-[#00E5FF]" /> Product design
              </li>
            </ul>
          </div>
        </FadeUp>

        <FadeUp delay={0.1} className="lg:col-span-5">
          <div className="card-lift group relative h-full max-h-[560px] overflow-hidden rounded-2xl border border-white/10 lg:max-h-none lg:min-h-[540px]" data-testid="about-image-card">
            <img
              src="/jacob.webp"
              alt="Jacob Tobery"
              className="h-full w-full object-cover object-[center_58%] grayscale transition-[filter] duration-700 group-hover:grayscale-0 lg:absolute lg:inset-0"
              data-testid="about-image"
            />
          </div>
        </FadeUp>
      </div>
    </section>
  );
}
